import script from "./NewsPageRubricsEditPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./NewsPageRubricsEditPopup.vue?vue&type=script&setup=true&lang=js"

import "./NewsPageRubricsEditPopup.vue?vue&type=style&index=0&id=3ddca746&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ddca746"]])

export default __exports__